// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/menu/MessagePopup.css
// module id = 2011
// module chunks = 0